import React, {Component} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'

import SaldoCajerosTable from './SaldoCajerosTable'
import { Alert, AlertTitle, Collapse, Paper, Snackbar } from '@mui/material'

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class SaldoCajerosPage extends Component {
    constructor() {
      super()

      this.state = {
        grupos: [],
        cajeros: [],
        registros: [],
        consultado : false,

        mostrarAlerta: false,
        mensajeAlerta: '',
        severidadAlerta: 'info'
      }

      this.btnBuscarClick = this.btnBuscarClick.bind(this)
      this.cmbGrupos = React.createRef()
      this.cmbCajeros = React.createRef()
      this.exportExcel = this.exportExcel.bind(this)
    }

    btnBuscarClick() {
    
      this.querySaldos() 
      this.setState({ consultado: true });
    }


    handleCloseAlert= (event, reason) => {
      if (reason === 'clickaway') {
        return; // Evitar que se cierre si el usuario hace clic fuera
      }
      this.setState({ mostrarAlerta: false })
    }

  queryGrupos() {
        
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/grupos/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando grupos")
        console.log('Error respuesta consultando grupos')
        this.setState({
          grupos: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando grupos',
          severidadAlerta: 'error'
        })
      } else {
        this.setState({
          grupos: data
        })
      }
    })
  }


  queryCajeros() {

     var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/cajerosconsultas/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando cajeros")
        console.log('Error respuesta consultando cajeros')
        this.setState({
          cajeros: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando cajeros',
          severidadAlerta: 'error'
        })
      } else {
        this.setState({
          cajeros: data
        })
      }
    })
    
   }

 querySaldos() {

    var filtroIdGrupo = ''
    var filtroIdCajero = ''

    if(this.cmbGrupos.current.value !== 0){
      filtroIdGrupo = this.cmbGrupos.current.value
    }

    if(this.cmbCajeros.current.value !== 0){
      filtroIdCajero = this.cmbCajeros.current.value
    }


    if(filtroIdGrupo === '' && filtroIdCajero === '') {
      this.setState({

        mostrarAlerta: true,
        mensajeAlerta: 'Debe seleccionar un grupo o un cajero',
        severidadAlerta: 'warning'
      })
      return
    }


    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
      filtro_id_grupo: filtroIdGrupo,
      filtro_id_cajero: filtroIdCajero
    },
      url: process.env.REACT_APP_URL_BACKEND + '/reportes/saldocajeros/'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        // alert("Error consultando saldos")
        console.log('Error respuesta consultando saldos')
        this.setState({
          registros: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando saldos',
          severidadAlerta: 'error'
        })
      } else {
        this.setState({
          registros: data
        })
      }
    })

}

calcularArqueoPorDetalle = (detalle) => {
    const arqueoMap = {
      automatico: new Map(),
      manual: 0 // solo sumamos el total de sobres
    };

    try {
      if (!detalle || !detalle.detalle) {
        console.warn("Sin detalle");
        return { automatico: [], manual: 0 };
      }

      // Convertimos el string JSON a un array válido (ya que puede venir concatenado)
      const arrayDetalle = `[${detalle.detalle}]`;
      const parsedDetalles = JSON.parse(arrayDetalle);

      parsedDetalles.forEach((contenido) => {
        Object.entries(contenido).forEach(([tipo, seccion]) => {
          if (tipo === "automatico" && seccion?.currencies) {
            // Desglose de billetes automáticos
            seccion.currencies.forEach((currency) => {
              currency.bills.forEach((bill) => {
                const denom = bill.denomination;
                const cantidad = bill.amount;

                if (arqueoMap.automatico.has(denom)) {
                  arqueoMap.automatico.set(denom, arqueoMap.automatico.get(denom) + cantidad);
                } else {
                  arqueoMap.automatico.set(denom, cantidad);
                }
              });
            });
          }

          // Si es manual, solo sumamos el total
          if (tipo === "manual" && seccion?.currencies) {
            seccion.currencies.forEach((currency) => {
              arqueoMap.manual += currency.total_bills || 0;
            });
          }
        });
      });
    } catch (e) {
      console.error("Error parseando el detalle:", e, detalle.detalle);
    }

    // Convertir el map de automático en array
    const arqueoAutomatico = Array.from(arqueoMap.automatico.entries())
      .sort((a, b) => b[0] - a[0])
      .map(([denominacion, cantidad]) => ({
        denominacion,
        cantidad,
        subtotal: denominacion * cantidad
      }));

    return {
      automatico: arqueoAutomatico,
      manual: arqueoMap.manual
    };
  };

  exportExcel() {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("SaldoCajeros");

    // Denominaciones esperadas (puedes ajustarlas según tu sistema)
    const denominaciones = [1000, 2000, 5000, 10000, 20000, 50000, 100000];

    // Encabezados dinámicos
    const headers = [
      { header: "Código cajero" },
      { header: "Alias cajero" },
      { header: "País" },
      { header: "Ciudad" },
      ...denominaciones.map((den) => ({ header: `Bill_${den}` })),
      { header: "Total Automático" },
      { header: "Total Sobres" },
      { header: "Saldo actual" },
    ];

    sheet.columns = headers;

    const records = this.state.registros;

    records.forEach((item) => {
      const arqueo = this.calcularArqueoPorDetalle(item);

      // Mapeamos denominaciones automáticas a un objeto rápido
      const mapaAuto = {};
      arqueo.automatico.forEach((b) => {
        mapaAuto[b.denominacion] = b.cantidad;
      });

      // Calculamos total de automático
      const totalAutomatico = arqueo.automatico.reduce(
        (sum, b) => sum + b.subtotal,
        0
      );

      // Creamos fila
      const row = [
        item.codigo_cajero,
        item.alias_cajero,
        item.pais,
        item.ciudad,
        ...denominaciones.map((den) => mapaAuto[den] || 0),
        totalAutomatico,
        arqueo.manual,
        item.saldo_actual,
      ];

      sheet.addRow(row);
    });

    // Estilos generales
    sheet.columns.forEach((col) => {
      col.width = 15;
    });

    // Guardar archivo
    const nombreArchivo = "SaldoCajeros.xlsx";

    workbook.xlsx.writeBuffer().then((data) => {
      FileSaver.saveAs(new Blob([data]), nombreArchivo);

      this.setState({
        mostrarAlerta: true,
        mensajeAlerta: "Archivo generado con éxito",
        severidadAlerta: "success",
      });
    });
  }


  componentDidMount() {
    this.queryGrupos()
    this.queryCajeros()
  }

    render() {
        return(
            <Box>
              <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
                Saldo cajeros 
              </Typography>
        
              <Paper elevation={16}>
                <Card sx={{ p: 2 }}>
                  <CardContent>
                    <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                      <Grid item container spacing={2}>
                        <Grid item xs={12}>
                          <Typography gutterBottom variant="h6" component="div">
                            Filtrar totales:
                          </Typography>
                        </Grid>
                        <Grid container spacing={2}> 
                          <Grid item xs={3}>
                            <FormControl fullWidth>
                              <InputLabel>Grupo</InputLabel>
                              <Select
                              label="Grupo"
                                inputRef={this.cmbGrupos}
                                defaultValue={0}>
                                <MenuItem value={0}>-- Seleccione --</MenuItem>
                                {this.state.grupos.map(grupo => (
                                  <MenuItem key={grupo.id} value={grupo.id}>{grupo.nombre}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl fullWidth>
                              <InputLabel>Cajero</InputLabel>
                              <Select
                                label="Cajero"
                                inputRef={this.cmbCajeros}
                                defaultValue={0}>
                                <MenuItem value={0}>-- Todos los cajeros --</MenuItem>
                                {this.state.cajeros.map(cajero => (
                                  <MenuItem key={cajero.id} value={cajero.id}>{cajero.alias}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={3}>
                            <CardActions>
                              <Button variant="contained" size="large" onClick={this.btnBuscarClick}>Buscar</Button>

                              <Snackbar
                                open={this.state.mostrarAlerta}
                                onClose={this.handleCloseAlert}
                                autoHideDuration={3000}
                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                              >
                                <Collapse in={this.state.mostrarAlerta}>
                                    <Alert
                                          severity={this.state.severidadAlerta}
                                          onClose={this.handleCloseAlert}
                                          sx={{ marginTop: 4, width:'100%'}}
                                              >
                                    <AlertTitle>
                                                  {this.state.severidadAlerta.toUpperCase()}
                                    </AlertTitle>
                                       {this.state.mensajeAlerta}
                                    </Alert>
                                </Collapse>
                              </Snackbar>
                            </CardActions>
                          </Grid>
                        </Grid>
                      
                      </Grid>
                    </Box>
                  </CardContent>
                
                </Card>

              </Paper>

              <br />

              <Paper elevation={16}>
                <Card>
                  <CardContent>
                    <Typography gutterBottom variant="h6" component="div">
                      Totales:
                    </Typography>
                    <Divider style={{"marginTop": 10, "marginBottom": 10}} />
                      { this.state.registros.length > 0 &&
                        <Button style={{"marginTop": 10, "marginBottom": 10}} variant='contained' onClick={this.exportExcel}>Exportar</Button>
                      }
                    <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                      {!this.state.consultado ? (
                        <Typography sx={{ mt: 3, textAlign: 'center', color: 'text.secondary' }}>
                          Realice una búsqueda para ver los resultados
                        </Typography>
                      ) : this.state.registros.length === 0 ? (
                        <Typography sx={{ mt: 3, textAlign: 'center', color: 'text.secondary' }}>
                          La bóveda está vacía
                        </Typography>
                      ) : (
                        <SaldoCajerosTable registros={this.state.registros} />
                      )}
                    </Box>
                  </CardContent>
                </Card>

              </Paper>

            </Box>
        )
    }

}

export default SaldoCajerosPage